import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '../../../../../common/StyledToolTip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = (theme) => ({
  alignMiddle: {
    verticalAlign: 'middle'
  },
  icon: {
    fontSize: '15px'
  }
});

const TimeRenderer = (params) => {
  const { data, classes, value } = params;
  if (data.isCompleted) {
    return <span>{value}</span>;
  }
  return (
    <Fragment>
      <span className={classes.alignMiddle}>{value} </span>
      <Tooltip title="RouteMAX ETA">
        <InfoOutlinedIcon className={`${classes.icon} ${classes.alignMiddle}`} color="primary" />
      </Tooltip>
    </Fragment>
  );
};

export default withStyles(styles)(TimeRenderer);
